import styled from "styled-components";
import { BREAKPOINTS } from "../../../app/appConstants.js";

export const InfoIconWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
`;

export const InfoIconSliderWrapperStyled = styled.div`
    padding: 0 16px;
    width: 100%;
`;

export const InfoIconTooltipWrapperStyled = styled.div`
    border-radius: 16px;
    padding: 16px;
    background: var(--color-surface-secondary);
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
`;

export const BonusInfoIconTooltipStyled = styled.div`
    font-size: 10px;
    width: 500px;

    ol {
        padding-left: 1rem;
        margin-bottom: 0;
    }

    li {
        margin-bottom: 4px;
    }

    a {
        color: var(--color-white);
        font-weight: 600;
    }

    @media (max-width: ${BREAKPOINTS.small}px) {
        width: 100%;
    }
`;
